import {IModalDialogHandler} from "../dialog/dialog.service.interface";
import {
    TimeSpentReminderWithBalanceComponentProps
} from "../../components/time-spent-reminder/with-balance/time-spent-reminder-with-balance.component.props";
import {
    TimeSpentReminderWithDropdownComponentProps
} from "../../components/time-spent-reminder/with-dropdown/time-spent-reminder-with-dropdown.component.props";


export interface IConfirmLugasCoolingOffLogoutDialogOptions {
    onAccept: () => Promise<void>;
    onReject: () => Promise<void>;
}

export enum DialogResult {
    Accepted,
    Rejected
}

export interface ShowTimeSpentReminderWithBalanceOptions extends Omit<TimeSpentReminderWithBalanceComponentProps, 'dialogHandler'> {
    onDialogClosed: () => void;
}

export interface ShowTimeSpentReminderWithDropdownOptions extends Omit<TimeSpentReminderWithDropdownComponentProps, 'dialogHandler'> {
    onDialogClosed: () => void;
}

export interface ISpecificDialogsService {
    enforceHybridAppModal(analyticsOnClick?: {
        category: string;
        action?: string;
        label?: string;
        value?: any;
        omitStructuredLogger?: boolean;}
    ): IModalDialogHandler;
    showLugasCooldownPopup(): IModalDialogHandler;
    showLugasActivePopup(): IModalDialogHandler;
    showConfirmLugasCoolingOffLogout(options: IConfirmLugasCoolingOffLogoutDialogOptions): Promise<DialogResult>;
    showLoginPopup(confirmClicked: ()=> void): Promise<IModalDialogHandler>;
    showModifyBiometricDialog(): IModalDialogHandler;
    showLogoutGamblingSessionSummary(): Promise<DialogResult>;
    showTimeSpentReminderWithBalance(options: ShowTimeSpentReminderWithBalanceOptions): IModalDialogHandler;
    showTimeSpentReminderWithDropdown(options: ShowTimeSpentReminderWithDropdownOptions): IModalDialogHandler;
}
